var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row deed-owner-details-content" }, [
    _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-sm-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialSelect",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("occupation_right_type_id"),
                      expression: "rulesField('occupation_right_type_id')",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    disabled: _vm.readonlyForm,
                    id: "input-right_type",
                    name: "right_type",
                    label: "name",
                    options: _vm.right_types,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError("right_type", _vm.vScope),
                      },
                    ],
                    error: _vm.fnFirstError("right_type", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.occupation_right_type_id,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "occupation_right_type_id",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.occupation_right_type_id",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.right_type`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialSelect",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("occupation_term_right_type_id"),
                      expression: "rulesField('occupation_term_right_type_id')",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    disabled: _vm.readonlyForm,
                    id: "input-term_right_type",
                    name: "term_right_type",
                    label: "name",
                    options: _vm.term_right_types,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "term_right_type",
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("term_right_type", _vm.vScope),
                  },
                  on: { selected: _vm.onSelectedTermRightType },
                  model: {
                    value: _vm.form.occupation_term_right_type_id,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "occupation_term_right_type_id",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.occupation_term_right_type_id",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.$t(`${_vm.modelTranslateID}.term_right_type`)
                      ) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialDatePicker",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("application_at"),
                      expression: "rulesField('application_at')",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    disabled: _vm.readonlyForm,
                    id: "input-application_at",
                    name: "application_at",
                    dateFormat: _vm.labelDateFormat,
                    databaseDateFormat: _vm.dateFormat,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "application_at",
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("application_at", _vm.vScope),
                  },
                  on: { input: _vm.onChangeApplicantAt },
                  model: {
                    value: _vm.form.application_at,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "application_at",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.application_at",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.application_at`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialDatePicker",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("expiry_at", {
                        dateAfter: [
                          _vm.form.application_at,
                          true,
                          _vm.$t(`${_vm.modelTranslateID}.application_at`),
                        ],
                      }),
                      expression:
                        "rulesField('expiry_at', {dateAfter: [form.application_at, true, $t(`${modelTranslateID}.application_at`)]})",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    disabled: _vm.readonlyForm,
                    id: "input-expiry_at",
                    name: "expiry_at",
                    dateFormat: _vm.labelDateFormat,
                    databaseDateFormat: _vm.dateFormat,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      { "is-invalid": _vm.fnHasError("expiry_at", _vm.vScope) },
                    ],
                    error: _vm.fnFirstError("expiry_at", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.expiry_at,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "expiry_at",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.expiry_at",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.expiry_at`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-4" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialInput",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("certificate_number"),
                      expression: "rulesField('certificate_number')",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    readonly: _vm.readonlyForm,
                    disabled: _vm.readonlyForm,
                    id: "input-certificate_number",
                    name: "certificate_number",
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "certificate_number",
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("certificate_number", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.certificate_number,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "certificate_number",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.certificate_number",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(
                        _vm.$t(`${_vm.modelTranslateID}.certificate_number`)
                      ) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-4" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialInput",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("process_number"),
                      expression: "rulesField('process_number')",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    readonly: _vm.readonlyForm,
                    disabled: _vm.readonlyForm,
                    id: "input-process_number",
                    name: "process_number",
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "process_number",
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("process_number", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.process_number,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "process_number",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.process_number",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.process_number`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-4" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialInput",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("license_number"),
                      expression: "rulesField('license_number')",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    readonly: _vm.readonlyForm,
                    disabled: _vm.readonlyForm,
                    id: "input-license_number",
                    name: "license_number",
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError(
                          "license_number",
                          _vm.vScope
                        ),
                      },
                    ],
                    error: _vm.fnFirstError("license_number", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.license_number,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "license_number",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.license_number",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.license_number`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-sm" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialInput",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("fee", {
                        decimal: _vm.priceDecimalPlaces,
                        min_value: 0,
                      }),
                      expression:
                        "rulesField('fee', {decimal: priceDecimalPlaces, min_value:0})",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    readonly: _vm.readonlyForm,
                    disabled: _vm.readonlyForm,
                    id: "input-fee",
                    name: "fee",
                    type: "number",
                    step: _vm.stepPriceDecimalPlaces,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      { "is-invalid": _vm.fnHasError("fee", _vm.vScope) },
                    ],
                    error: _vm.fnFirstError("fee", _vm.vScope),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "grpAppend",
                      fn: function () {
                        return [
                          _c("span", { staticClass: "input-group-text" }, [
                            _vm._v(_vm._s(_vm.currency.symbol)),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.form.fee,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "fee",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.fee",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.fee`)) +
                      "\n                        "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialDatePicker",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "",
                      expression: "''",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    disabled: _vm.readonlyForm,
                    id: "input-payment_at",
                    name: "payment_at",
                    dateFormat: _vm.labelDateFormat,
                    databaseDateFormat: _vm.dateFormat,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      {
                        "is-invalid": _vm.fnHasError("payment_at", _vm.vScope),
                      },
                    ],
                    error: _vm.fnFirstError("payment_at", _vm.vScope),
                  },
                  model: {
                    value: _vm.form.payment_at,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "payment_at",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.payment_at",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.payment_at`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-sm align-self-center form-group" },
          [
            _c(
              "div",
              { staticClass: "form-check city-form-check form-check-inline" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.form.fee_paid,
                      expression: "form.fee_paid",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    readonly: _vm.readonlyForm,
                    disabled: _vm.readonlyForm,
                    type: "checkbox",
                    id: "input-fee_paid",
                    name: "fee_paid",
                    "false-value": false,
                    "true-value": true,
                  },
                  domProps: {
                    checked: Array.isArray(_vm.form.fee_paid)
                      ? _vm._i(_vm.form.fee_paid, null) > -1
                      : _vm.form.fee_paid,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.form.fee_paid,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.form, "fee_paid", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "fee_paid",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "fee_paid", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label h-auto",
                    attrs: { for: `input-fee_paid` },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column align-items-start" },
                      [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t(`${_vm.modelTranslateID}.fee_paid`))
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-sm-12" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "MaterialTextarea",
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rulesField("obs"),
                      expression: "rulesField('obs')",
                    },
                  ],
                  staticClass: "city-form-group city-bg",
                  attrs: {
                    readonly: _vm.readonlyForm,
                    disabled: _vm.readonlyForm,
                    id: `input-obs`,
                    name: `obs`,
                    rows: 3,
                    "data-vv-scope": _vm.vScope,
                    inputClasses: [
                      { "is-invalid": _vm.fnHasError(`obs`, _vm.vScope) },
                    ],
                    error: _vm.fnFirstError(`obs`, _vm.vScope),
                  },
                  model: {
                    value: _vm.form.obs,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.form,
                        "obs",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "form.obs",
                  },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t(`${_vm.modelTranslateID}.obs`)) +
                      "\n                    "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-sm-12" },
          [
            _c("DeedOwnerFiles", {
              attrs: {
                panelCfg: _vm.panelCfg,
                vScope: _vm.vScope,
                readonlyForm: _vm.readonlyForm,
                baseTranslateID: _vm.baseTranslateID,
              },
              model: {
                value: _vm.form.files,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "files", $$v)
                },
                expression: "form.files",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }